import AddressBase from '../_Base/AddressBase';
import ApplicationsResidenceStatus from '../Applications/ApplicationsResidenceStatus';

export default class CustomerResidence extends AddressBase {
	movedInDate?: Date;
	residenceStatus?: ApplicationsResidenceStatus;
	homePhoneNumber?: string;

	constructor(init?: Partial<CustomerResidence>) {
		super(init);
		if (init) {
			this.movedInDate = init.movedInDate;
			this.residenceStatus = init.residenceStatus;
			this.homePhoneNumber = init.homePhoneNumber;
		}
	}
}
